import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Hello, World!</h1>
    </div>
  );
};

export default Dashboard;